export const NOT_STARTED = 0;
export const LOADED = 1;
export const LOADING = 2;
export const ERROR = -1;